import type { IPositionMeasurement } from '@lucimark/shared/models/geolocation'
import { isPlayerPositionMeasurementStale } from '@lucimark/shared/helpers/playerPositionStaleness'

/** Movement beyond accuracy, or last uplink older than Studio freshness (`DEFAULT_PLAYER_POSITION_STALE_MS`). */
export function shouldUplinkGeolocationSample(params: {
  lastReported: Pick<IPositionMeasurement, 'timestamp'> | null
  distanceMeters: number | null
  sampleAccuracyMeters: number
  nowMs: number
}): boolean {
  if (params.distanceMeters === null || params.distanceMeters > params.sampleAccuracyMeters) {
    return true
  }
  return isPlayerPositionMeasurementStale(params.lastReported, params.nowMs)
}
